module.exports = __webpack_public_path__ + "img/logo-text.ab70dddd.png";